﻿import { defineComponent, nextTick } from 'vue';
import header_menu from "../header/menu.vue"
import hero from "../header/hero.vue"
import footer_item from "../base/common/footer.vue"
import gift_card from "./gift_card.vue";
import cart_preview_button from "./cart_preview_button.vue";

import searchfilter from "../base/1_search/searchfilter.vue"
import filter_buttons from "../base/1_search/tour_list/filter_buttons.vue";
import search_calendar from "../base/1_search/calendar/calendar.vue";
import tour_card from "../base/1_search/tour_card.vue"
import tour_details from "../base/2_tour_details/tour_details.vue"
import embedded_calendar from "../base/2_tour_details/embedded_calendar.vue"
import tour_filter_panel from "./tour_filter_panel.vue";

import { Booking } from "../../services/booking";
import { Currency_Service } from "../../../system/services/currency";
import { Product } from '../../services/product';
import { Web_Engine } from "../../services/web_engine";

import { product_search } from '../../objects/v1_3/product/search/product_search';
import { week_day } from '../../objects/front_end/calendar/week_day';
import { product_search_product } from '../../objects/v1_3/product/search/product_search_product';
import { filtertag } from '../../objects/v1_3/web_engine/filtertag';

const Book = new Booking;
const Currency_Services = new Currency_Service;
const Prod = new Product;
const Web_Engines = new Web_Engine;

export default defineComponent({
    components: {
        footer_item,
        header_menu,
        hero,
        searchfilter,
        filter_buttons,
        tour_card,
        tour_details,
        embedded_calendar,
        gift_card,
        tour_filter_panel,
        cart_preview_button,
        search_calendar,
    },
    props: {
    },
    // read by the tour's booking calendar (2_tour_details: tour_details.ts, calendar_day.ts); absent on other pages
    provide() {
        return {
            preferredDeparture: {
                get: (): string => this.preferred_departure_date(),
                set: (output_date: string) => this.Set_Preferred_Departure(output_date)
            }
        };
    },
    data() {
        return {
            all_products: new product_search() as product_search,
            product_search: new product_search() as product_search,
            isHidden: true as boolean,
            tour_id: this.$route.query.tour_id as string,
            trip_index: 0 as number,
            loading_search: false as boolean,
            search_request: 0 as number,
            // the side filter panel's active filters (tour_filter_panel chipsChange), shown as pills above the results
            filter_chips: [] as { section: string; value?: string; label: string }[],
            filter_date_chip: null as { label: string; canStep: boolean; canStepBack: boolean } | null,
            // yyyy-mm-dd picked in the toolbar calendar's tour list (single-date mode), used to preselect that date in the tour
            tour_list_date: "" as string,
            // calendar slide-out opened from the filter row (side panel mode); only created on first open
            dates_calendar_open: false as boolean,
            dates_calendar_created: false as boolean,
            dep_date_from: new week_day() as week_day,
            dep_date_to: new week_day() as week_day,
            in_cart: new product_search() as product_search,
            products_to_display: new product_search() as product_search,
            openedFromQueryOnce: false as boolean,
            products_base_to_display: new product_search() as product_search,
            filterToIds: [] as string[],
            show_gift_card: false as boolean,
            gift_card_product: null as product_search_product | null,
            gift_card_loading: false as boolean,
            excluded_tours: [] as string[]
        }
    },
    methods: {
        async fetchExcludedTours(): Promise<void> {
            const apiUrl = import.meta.env.VITE_DASHBOARD_API_URL;
            const apiKey = import.meta.env.VITE_DASHBOARD_API_KEY;
            if (!apiUrl || !apiKey) return;
            try {
                const response = await fetch(`${apiUrl}/admin/tours/hidden`, {
                    headers: { 'X-Api-Key': apiKey }
                });
                if (!response.ok) return;
                const data: { tour_code: string }[] = await response.json();
                this.excluded_tours = data.map(t => t.tour_code.trim().toUpperCase());
            } catch {
                // leave excluded_tours empty so no tours are hidden on error
            }
        },
        async download_product_search() {
            // searches can overlap (e.g. clicking the next/previous day quickly); only the latest one may update the results
            const request = ++this.search_request;
            this.loading_search = true;
            this.product_search = new product_search();


            //Occasionally tour Id returns as GUID, this loop will keep trying until all tour Ids are standard 4 or less chars
            let product_search_call_results = await Prod.Get_Product_Search_Filtered(this.$store.getters.get_Search_Filter_Tags, this.$store.getters.get_Search_Tags, this.$store.getters.get_Search_Products, this.dep_date_from.output_date ?? "", this.departure_to_exclusive());
            if (request != this.search_request) {
                return;
            }
            let passedTourIdCheck = false;

            let retryCount = 0;
            while(!passedTourIdCheck) {
                let failedIDFound = false;
                product_search_call_results.products.forEach((product) => {
                    if (product.tour_id.length > 4) {
                        failedIDFound = true;
                    }
                });
                if (failedIDFound) {
                    retryCount++;
                    product_search_call_results = await Prod.Get_Product_Search_Filtered(this.$store.getters.get_Search_Filter_Tags, this.$store.getters.get_Search_Tags, this.$store.getters.get_Search_Products, this.dep_date_from.output_date ?? "", this.departure_to_exclusive());
                }
                else {
                    passedTourIdCheck = true;
                }

                if(retryCount > 3) {
                    passedTourIdCheck = true;
                }
            }

            if (request != this.search_request) {
                return;
            }

            this.all_products = Prod.Filtered_Products(this.$store.getters.get_Basket, product_search_call_results);
            this.in_cart = Prod.Filtered_out_Products(this.$store.getters.get_Basket, product_search_call_results);

            this.all_products.products.forEach((product) => {
                let ignore = false;

                if(this.product_search.products.length > 0) { 
                    let index = 0;
                    this.product_search.products.forEach((product_search) => {
                        if(import.meta.env.VITE_PRODUCTS_HIDE_DUPLICATES == 'true' && this.FormatForCompare(product_search.name) == this.FormatForCompare(product.name) && product_search.brand == product.brand){
                            const currentPrice = this.getPrice(product_search);
                            const newPrice = this.getPrice(product);
                            if ((newPrice > 0 && (currentPrice === 0 || newPrice < currentPrice))) {
                                this.product_search.products.splice(index, 1);
                                this.product_search.products.push(product);
                            }
                            ignore = true;
                        }
                        index++;
                    });
                }

                const hide_zero : boolean = import.meta.env.VITE_PRODUCTS_HIDE_ZERO_PRICED_PRODUCTS == 'true';
                if (ignore == false && hide_zero ==true) {
                    if (this.getPrice(product) == 0) {
                        ignore = true;
                    }
                }

                if(!ignore){
                    this.product_search.products.push(product);
                }
            });

            this.gift_card_product = await this.getGiftCardProduct();
            if (request != this.search_request) {
                return;
            }

            this.products_to_display.products = this.includedTours(this.product_search.products)
                .filter((p: any) => p?.tour_id !== this.gift_card_product?.tour_id);
            this.products_base_to_display.products = [...this.products_to_display.products];
            this.applyFilterToFromQuery();
            this.loading_search = false;
        },
        async getGiftCardProduct(): Promise<product_search_product | null> {
            if (!this.product_search.products) return null;

            const filters = this.$store.getters.get_Search_Filters;

            const giftCardFilter = filters?.find(
                (filter: any) => filter.name.toLowerCase() === 'gift cards'
            );

            if (!giftCardFilter) return null;

            const brand = this.GetBrand();

            const matchingTag = giftCardFilter.tags?.find(
                (tag: any) => tag.name === brand
            );

            if (!matchingTag) return null;

            const result = await Prod.Get_Product_Search_Filtered([], [matchingTag], '', '', '');

            return result?.products?.[0] ?? null;
        },
        GetBrand(): string {
            return String(import.meta.env.VITE_DEFAULT_CLASS);
        },
        getFilterToIdsFromQuery(): string[] {
            const raw = (this.$route.query?.filterto ?? '').toString().trim();
            if (!raw) return [];
            return raw
                .split(/[,\|]/)
                .map(s => s.trim().toUpperCase())
                .filter(Boolean);
        },
        applyFilterToFromQuery() {
            this.filterToIds = this.getFilterToIdsFromQuery();

            if (this.filterToIds.length === 0) {
                this.products_to_display.products = [...this.products_base_to_display.products];
                return;
            }

            const wanted = new Set(this.filterToIds);
            const base = this.products_base_to_display.products ?? [];
            this.products_to_display.products = base.filter(p => {
                const id = String(p?.tour_id ?? '').toUpperCase();
                return wanted.has(id);
            });
        },
        showAllTours() {
            const q: Record<string, any> = { ...this.$route.query };
            delete q.filterto;
            this.$router.push({ path: this.$route.path, query: q }).then(() => {
                this.products_to_display.products = [...this.products_base_to_display.products];
            });
        },

        FormatForCompare(name: string): string {
            return name.toLowerCase().replace("(hotel)", "").replace("(b&b)","");
        },
        async Setup_Currency() {
            if (this.getSession_ID() != "") {
                await Book.Get_Session_Information(Web_Engines.getSession_ID()).then(async (User_Info) => {
                    this.$store.commit("Set_Booking_Login", { Booking_Login: User_Info });
                    await Web_Engines.Initialise_Currency(this.$store, User_Info.booking_info.iso_currency_code);
                    this.$store.commit("Initialise_Basket", { Currency: User_Info.booking_info.iso_currency_code, Trip_Index: 0, Tour_ID: "" });

                    if (User_Info.booking_info?.booking_identifier + "" != "" && User_Info.booking_info?.booking_identifier != undefined) {
                        await Book.Download_Booking(User_Info.booking_info.booking_identifier).then(async (Booking_Details) => {
                            this.$store.commit("Setup_Existing_Booking", { Booking_Details: Booking_Details });
                        });
                    }
                });
            } else {
                await Web_Engines.Initialise_Currency(this.$store, this.getOverrideCurrencyFromQueryString());
            }
        },
        getSession_ID(): string {
            let url = window.location.href;
            let params = url.split("/");
            let displayText = "";

            if (params.length > 0) {
                if (this.isValidGUID(params[params.length - 1])) {
                    return params[params.length - 1];
                }
            }

            return displayText;
        },
        isValidGUID(value: string): boolean {
            const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
            return guidRegex.test(value);
        },
        getOverrideCurrencyFromQueryString() : string {
            let curcur = '';
            if (this.$route.query.cur != null) {
                curcur = this.$route.query.cur.toString().toLowerCase();
            }

            return curcur;
        },
        getPrice(product: product_search_product): number {
            return Prod.product_pricing(Book.Pricing_Age_Category(this.$store), this.$store.getters.get_Currency, product ?? new product_search_product())
        },
        onBookTour(tour_id: string)
        {
            if (tour_id != this.tour_id) {
                this.tour_id = tour_id;
            }

            this.trip_index = this.get_Tour_Length();
            this.$refs.tour_details.download_product(tour_id);
            this.$store.commit('Initialise_Basket', { Currency: this.$store.getters.get_Currency?.currency_info?.iso_currency_code, Trip_Index: this.trip_index, Tour_ID: tour_id });

            this.isHidden = false;
        },
        get_Tour_Length(): number {
            if (this.$store.getters.get_Basket?.trips.length == 1) {
                if (this.$store.getters.get_Basket?.trips[0].tour_id == "" || this.$store.getters.get_Basket?.trips[0].departure_date == "") {
                    return 0;
                }
            }

            return this.$store.getters.get_Basket?.trips.length;
        },
        onFilterChange() {
            this.download_product_search();
        },
        // Returns a sorted copy (never mutates the list passed in).
        sortBy(sortby: string, source: product_search_product[]): product_search_product[] {
            const productSearch = [...source];
            if (sortby && sortby !== "default") {

                if (sortby === "price_asc") {
                    return productSearch.sort((a, b) => {
                        return this.getPrice(a) - this.getPrice(b);
                    });
                }
                if (sortby === "price_desc") {
                    return productSearch.sort((a, b) => {
                        return this.getPrice(b) - this.getPrice(a);
                    });
                }

                if (sortby === "duration_asc") {
                    return productSearch.sort((a, b) => {
                        const aTotal = (a.duration?.days ?? 0) * 24 + (a.duration?.hours ?? 0);
                        const bTotal = (b.duration?.days ?? 0) * 24 + (b.duration?.hours ?? 0);
                        return aTotal - bTotal;
                    });
                }
                if (sortby === "duration_desc") {
                    return productSearch.sort((a, b) => {
                        const aTotal = (a.duration?.days ?? 0) * 24 + (a.duration?.hours ?? 0);
                        const bTotal = (b.duration?.days ?? 0) * 24 + (b.duration?.hours ?? 0);
                        return bTotal - aTotal;
                    });
                }
                if(sortby === "alphabetical_desc") {
                    return productSearch.sort((a, b) => {
                        return a.name.localeCompare(b.name);
                    });
                }
                if(sortby === "alphabetical_asc") {
                    return productSearch.sort((a, b) => {
                        return b.name.localeCompare(a.name);
                    });
                }
            }
            return productSearch;
        },
        onStrictFilterChange(filter: { brand: string, duration: string, departure: string, sort: string }) {
            // Start from the visible tours (hidden tours and the gift card product already removed).
            let newList: product_search_product[] = [...this.filteredTours];

            // Brand options are the tours' own brand codes (e.g. "hag", "hex"); "highland" kept for older links.
            const brand = filter.brand?.toLowerCase().trim() ?? "";
            if (brand !== "") {
                const code = brand.includes("highland") ? "hex" : brand;
                newList = newList.filter(product => product.brand?.toLowerCase().includes(code));
            }

            const duration = filter.duration?.toLowerCase().trim() ?? "";
            if (duration.includes("2-8")) {
                newList = newList.filter(product => (product.duration?.days ?? 0) > 0);
            } else if (duration !== "") {
                newList = newList.filter(product => product.duration && product.duration.days === 0);
            }

            // Departure options are start-location cities/titles.
            const departure = filter.departure?.toLowerCase().trim() ?? "";
            if (departure !== "") {
                newList = newList.filter(product =>
                    (product.start_location?.city ?? "").toLowerCase().includes(departure) ||
                    (product.start_location?.title ?? "").toLowerCase().includes(departure));
            }

            this.products_to_display.products = this.sortBy(filter.sort, newList);
        },
        // the API's departure_date_to is the start (midnight) of that day, so to include departures on the last selected
        // day the search goes up to the day after it (a single day 2026-11-01 searches 2026-11-01 to 2026-11-02)
        departure_to_exclusive(): string {
            const output_date = this.dep_date_to?.output_date ?? "";
            if (output_date == "") {
                return "";
            }

            const parts = String(output_date).split("-").map(Number);
            const date = new Date(parts[0], parts[1] - 1, parts[2] + 1);
            return date.getFullYear() + "-" + String(date.getMonth() + 1).padStart(2, "0") + "-" + String(date.getDate()).padStart(2, "0");
        },
        onSearchChanges(dep_date_from: week_day, dep_date_to: week_day) {
            this.dep_date_from = dep_date_from;
            this.dep_date_to = dep_date_to;

            this.download_product_search();
        },
        onTagChanges() {
            this.download_product_search();
        },
        Add_To_Cart() {
            if (Web_Engines.getSession_ID() + "" == "") {
                this.$router.push({ path: "/cart" });
            } else {
                this.$router.push({ path: "/" + Web_Engines.get_Booking_URL() + "/cart/" + Web_Engines.getSession_ID() });
            }
        },
        getSearchHeader(): string {
            let returnString = "";
            if (this.getMinPPPrice() > 0)
            {
                returnString = import.meta.env.VITE_DEFAULT_HERO_TEXT + " " + Currency_Services.Format_Currency(this.getMinPPPrice(), this.$store.getters.get_Currency) + "pp";
            }

            return returnString;
        },
        getMinPPPrice(): number {
            return Prod.get_minimum_price(Book.Pricing_Age_Category(this.$store), this.$store.getters.get_Currency, this.product_search);
        },
        getLoadingText(): string {
            if(window.location.href.toLowerCase().includes("open")){
                return "Loading your tour";
            }
            else{
                return "Loading Search Information";
            }
        },
        getSearchTitle(): string {
            return String(import.meta.env.VITE_DEFAULT_HERO_TITLE);
        },
        getHeroImage(): string {
            return String(import.meta.env.VITE_DEFAULT_HERO_IMAGE);
        },
        Tour_Selected(travel_date: string, tour_id: string) {
            // travel_date comes from the calendar as yyyy/m/d
            const parts = (travel_date ?? "").split("/");
            this.tour_list_date = parts.length == 3 ? parts[0] + "-" + parts[1].padStart(2, "0") + "-" + parts[2].padStart(2, "0") : "";

            this.onBookTour(tour_id);
        },
        // Date sync between the search's date filter and a tour's booking calendar (provided to tour_details/calendar_day):
        // the date to jump to and preselect when a tour opens (yyyy-mm-dd, '' = none) ...
        preferred_departure_date(): string {
            return this.$refs.filter_panel?.dateFrom
                || this.dep_date_from?.output_date
                || this.tour_list_date
                || "";
        },
        // ... and a date picked in the tour's calendar becomes the side panel's travel date
        Set_Preferred_Departure(output_date: string) {
            this.$refs.filter_panel?.setTravelDate(output_date);
        },
        Reset_Basket() {
            this.$store.commit("Remove_Product", { Tour_ID: this.$store.getters.get_Basket?.trips[this.trip_index].tour_id });
            this.isHidden = true;
        },
        detectKeyPress(event: KeyboardEvent) {
            if (event.key === "Escape") {
                this.Reset_Basket();
            }
        },
        getOpenFromQuery(): string {
            const v = (this.$route.query.open ?? '').toString().trim();
            return v.toUpperCase();
        },
        getTourPairsMap(): Map<string, string[]> {
            // VITE_TOUR_PAIRS format: "EARLY1:LATE1,EARLY2:LATE2"
            const raw = (import.meta.env.VITE_TOUR_PAIRS ?? '').toString().trim();
            const map = new Map<string, string[]>();
            if (!raw) return map;
            for (const pair of raw.split(',')) {
                const ids = pair.split(':').map((s: string) => s.trim().toUpperCase()).filter(Boolean);
                if (ids.length >= 2) {
                    for (const id of ids) map.set(id, ids);
                }
            }
            return map;
        },
        maybeOpenFromQueryOnce() {
            if (this.openedFromQueryOnce) return;

            const open = this.getOpenFromQuery();
            if (!open) {
                this.applyFilterToFromQuery();
                return;
            }

            const pairs = this.getTourPairsMap();
            if (pairs.has(open)) {
                const filterto = pairs.get(open)!.join(',');
                const q = { ...this.$route.query };
                delete q.open;
                q.filterto = filterto;
                this.$router.replace({ path: this.$route.path, query: q });
                this.openedFromQueryOnce = true;
                return;
            }

            const match = this.products_to_display.products.find(
                p => (p.tour_id ?? '').toUpperCase().trim() === open
            );
            if (match) {
                this.onBookTour(match.tour_id);   // opens the popup
                this.openedFromQueryOnce = true;
            }
        },
        EmbedCheck(): boolean {
            return this.$route.query.embed !== undefined
        },
        EmbededTour(productSearch: product_search_product[]): product_search_product {
            const open = (this.$route.query.open ?? '').toString().toUpperCase().trim();
            if (!open) return { ...new product_search_product(), tour_id: "NUL" };

            const match = productSearch.find(tour => tour.tour_id?.toUpperCase().trim() === open);
            return match ?? { ...new product_search_product(), tour_id: "NUL" };
        },
        CartCountCheck(){
            //counts as 1 item in cart if refreshed when viewed. This checks if passengers are zero and clears basket if they are
            if((this.$store.getters.get_Basket.trips.length + Book.getTotal_Add_Ons(this.$store.getters.get_Basket) == 1) && this.$store.getters.get_Basket.passengers.toString() == ''){
                this.Reset_Basket();
            }
            
        },
        CartCount(): number {
            return this.$store.getters.get_Basket.trips.length;
        },
        includedTours(productSearch: product_search_product[]): product_search_product[] {
            if (this.excluded_tours.length === 0) {
                return productSearch;
            }
            return productSearch.filter(tour => !this.excluded_tours.includes(tour.tour_id.toUpperCase()));
        },
        localUrl(): boolean {
            if (window.location.href.includes("localhost")) {
                return true;
            }
            return false;
        },
        isHEXorHAG(): boolean {
            if (import.meta.env.VITE_DEFAULT_CLASS == "HEX" || import.meta.env.VITE_DEFAULT_CLASS == "HAG") {
                return true;
            }
            return false;
        },
        async open_gift_card(): Promise<void> {
            this.gift_card_loading = true;
    
            const product = await this.getGiftCardProduct();
    
            if (!product) {
                this.gift_card_loading = false;
                return;
            }
    
            this.gift_card_product = product;
            this.show_gift_card = true;
            this.gift_card_loading = false;
    
            this.$router.replace({
                query: { ...this.$route.query, view: "giftcard" }
            });
        },
    
        close_gift_card(): void {
            this.show_gift_card = false;
            this.gift_card_product = null;
            const query = { ...this.$route.query };
            delete query.view;
            this.$router.replace({ query });
        },
        onFilterPanelChange(filtered: product_search_product[]) {
            this.products_to_display.products = filtered;
        },
        onFilterChipsChange(state: { chips: { section: string; value?: string; label: string }[]; date: { label: string; canStep: boolean; canStepBack: boolean } | null }) {
            this.filter_chips = state.chips;
            this.filter_date_chip = state.date;
        },
        Remove_Filter_Chip(chip: { section: string; value?: string }) {
            this.$refs.filter_panel?.removeChip(chip.section, chip.value);
        },
        Clear_Filter_Chips() {
            this.$refs.filter_panel?.clearAll();
        },
        Step_Filter_Dates(days: number) {
            this.$refs.filter_panel?.stepDates(days);
        },
        Open_Filter_Dates() {
            this.$refs.filter_panel?.openDates();
        },
        // the Dates button / date pill in the filter row: open the calendar slide-out on the side panel's current dates
        async Open_Dates_Calendar() {
            const reopening = this.dates_calendar_created;
            this.dates_calendar_created = true;
            await this.$nextTick();

            const calendar = this.$refs.dates_calendar;
            const panel = this.$refs.filter_panel;
            calendar?.Sync_Selection(panel?.dateFrom ?? "", panel?.dateTo ?? "");
            if (reopening && (calendar?.months?.length ?? 0) > 0) {
                // the filter pills may have changed since it was last open: refresh the month's departures
                calendar.onFilterChanges();
            }
            this.dates_calendar_open = true;
        },
        // dates applied (or cleared) in the slide-out become the side panel's travel dates
        onDatesCalendarChange(dep_date_from: week_day, dep_date_to: week_day) {
            this.dates_calendar_open = false;
            this.$refs.filter_panel?.setDates(dep_date_from?.output_date ?? "", dep_date_to?.output_date ?? "");
        },
        // single-date mode: a day clicked in the slide-out (which then lists that day's tours) also becomes the travel date
        onDatesCalendarPicked(output_date: string) {
            this.$refs.filter_panel?.setTravelDate(output_date);
        },

    },
    async mounted() {
        document.body.style.overflow = '';
        await this.fetchExcludedTours();
        await this.Setup_Currency();
        await this.download_product_search();

        if (this.useFilterPanel) {
            Web_Engines.Get_Filters().then(filters => {
                this.$store.commit("Setup_Filter", { Filter_Items: filters });
            });
        }
      
        if (this.tour_id != undefined) {
            this.onBookTour(this.tour_id);
        }
        const unwatch = this.$watch(
            () => this.loading_search,
            async (isLoading) => {
            if (isLoading) return;
            await nextTick();
            this.maybeOpenFromQueryOnce();

            if (this.$route.query.view === "giftcard") {
                this.open_gift_card();
            }

            unwatch();
            },
            { immediate: true }
        );
        
        this.$watch(() => this.$route.query.filterto, () => {
            if (!this.loading_search) this.applyFilterToFromQuery();
        });

        this.CartCountCheck();
        window.addEventListener("keydown", this.detectKeyPress);

    },
    watch: {
        isHidden(val) {
            document.body.style.overflow = val ? '' : 'hidden';
        },
        "$route.query.view"(val: string) {
            if (val === "giftcard") {
                this.open_gift_card();
            } else {
                this.show_gift_card = false;
                this.gift_card_product = null;
            }
        }
    },
    unmounted() {
        document.body.style.overflow = '';
    },
    computed: {
       filteredTours(): product_search_product[] {
            const giftCardId = this.gift_card_product?.tour_id;
            return this.includedTours(this.product_search?.products ?? [])
                .filter(p => !giftCardId || p?.tour_id !== giftCardId);
        },
        embeddedTour(): product_search_product {
            return this.EmbededTour(this.products_to_display.products);
        },
        filterMessage(): string | null {
            const raw = (this.$route.query?.message ?? '').toString();
            if (!raw) return null;

            try {
            // decode %XX safely
            const decoded = decodeURIComponent(raw).trim();
            if (!decoded) return null;

            // guardrails: collapse whitespace & cap length
            const normalized = decoded.replace(/\s+/g, ' ');
            return normalized.length <= 100 ? normalized : normalized.slice(0, 100) + '…';
            } catch {
            // if malformed encoding, just show the raw (escaped in template)
            return raw.trim() || null;
            }
        },
        useFilterPanel(): boolean {
            return import.meta.env.VITE_FILTER_PANEL === 'true';
        }
        
    }
})